/* ============================================
   Falsabih Marine AI Assistant — Widget Logic
   ============================================ */
(function () {
  'use strict';

  /* ---- Configuration ---- */
  const CONFIG = {
    apiUrl: 'https://api.anthropic.com/v1/messages',
    apiKey: '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',
    shopDomain: 'https://falsabih.com',
    model: 'claude-sonnet-4-20250514',
    maxTokens: 600,
    systemPrompt: `You are the Falsabih Marine Assistant — a knowledgeable marine expert for Fahad AlSabih Marine Services (falsabih.com), Kuwait's leading marine accessories store with 23+ years of experience.

Help customers find products, answer marine questions, and provide store info.
Store: falsabih.com | Phone: +965 24922191 | Free shipping over 50 KD
Authorized Tohatsu dealer. 82 brands including JL Audio, Lowrance, SEAFLO, Shadow-Caster, Kicker, Spinlock.
Respond in the same language the customer uses (Arabic or English).
Never guess prices — direct to product page. Never make up products.
Keep responses concise (under 150 words). If a product search is relevant, include the keyword in [SEARCH:keyword] format and the system will show results.`,
    welcomeEN: 'How can I help you today?',
    welcomeAR: 'كيف يمكنني مساعدتك؟',
    placeholderEN: 'Ask about marine products…',
    placeholderAR: 'اسأل عن منتجات بحرية…',
    chipLabels: [
      { en: 'Find a product', ar: 'ابحث عن منتج' },
      { en: 'Free shipping?', ar: 'شحن مجاني؟' },
      { en: 'Store hours', ar: 'ساعات العمل' },
      { en: 'Contact us', ar: 'تواصل معنا' }
    ]
  };

  /* ---- State ---- */
  let isOpen = false;
  let isRTL = false;
  let conversation = [];
  let sending = false;

  /* ---- Arabic Detection ---- */
  const ARABIC_RE = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
  function detectArabic(text) {
    const arabicChars = (text.match(/[\u0600-\u06FF]/g) || []).length;
    return arabicChars > text.length * 0.3;
  }

  /* ---- DOM Builder ---- */
  function buildWidget() {
    /* Trigger button */
    const trigger = el('button', { id: 'fab-chat-trigger', 'aria-label': 'Open Marine Assistant' });
    trigger.innerHTML = `
      <svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 5.58 2 10c0 2.24 1.14 4.26 3 5.7V22l4.2-2.33c.9.21 1.84.33 2.8.33 5.52 0 10-3.58 10-8S17.52 2 12 2zm0 14.5c-.73 0-1.43-.1-2.1-.28l-.53-.15-2.37 1.32V15.1l-.57-.44C5 13.5 4 11.84 4 10c0-3.31 3.58-6 8-6s8 2.69 8 6-3.58 6-8 6z"/><circle cx="8" cy="10" r="1.2"/><circle cx="12" cy="10" r="1.2"/><circle cx="16" cy="10" r="1.2"/></svg>
      <span class="fab-badge"></span>`;
    trigger.addEventListener('click', togglePanel);

    /* Chat panel */
    const panel = el('div', { id: 'fab-chat-panel' });
    panel.innerHTML = `
      <div class="fab-header">
        <div class="fab-header-logo">
          <svg viewBox="0 0 24 24"><path d="M3 18h1.5l1-2h13l1 2H21l-3-6V8a3 3 0 00-3-3H9a3 3 0 00-3 3v4l-3 6zm5-10a1 1 0 011-1h6a1 1 0 011 1v3H8V8z"/><path d="M6 20h12v1H6z" opacity=".4"/></svg>
        </div>
        <div class="fab-header-info">
          <div class="fab-header-title">Marine Assistant</div>
          <div class="fab-header-subtitle">Falsabih · Online</div>
        </div>
        <button class="fab-header-close" aria-label="Close">
          <svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>
        </button>
      </div>
      <div class="fab-messages" id="fab-messages">
        <div class="fab-welcome">
          <div class="fab-welcome-icon">
            <svg viewBox="0 0 24 24"><path d="M3 18h1.5l1-2h13l1 2H21l-3-6V8a3 3 0 00-3-3H9a3 3 0 00-3 3v4l-3 6zm5-10a1 1 0 011-1h6a1 1 0 011 1v3H8V8z"/></svg>
          </div>
          <h3>Ahlan! مرحبا</h3>
          <p id="fab-welcome-text">${CONFIG.welcomeEN}</p>
        </div>
        <div class="fab-chips" id="fab-chips"></div>
        <div class="fab-typing" id="fab-typing">
          <div class="fab-typing-dot"></div>
          <div class="fab-typing-dot"></div>
          <div class="fab-typing-dot"></div>
        </div>
      </div>
      <div class="fab-input-area">
        <input class="fab-input" id="fab-input" type="text" placeholder="${CONFIG.placeholderEN}" autocomplete="off" />
        <button class="fab-send-btn" id="fab-send" aria-label="Send">
          <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
        </button>
      </div>
      <div class="fab-footer">Powered by Falsabih AI</div>`;

    document.body.appendChild(trigger);
    document.body.appendChild(panel);

    /* Event listeners */
    panel.querySelector('.fab-header-close').addEventListener('click', togglePanel);
    const input = panel.querySelector('#fab-input');
    const sendBtn = panel.querySelector('#fab-send');
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } });
    input.addEventListener('input', () => {
      const newRTL = detectArabic(input.value);
      if (newRTL !== isRTL) {
        isRTL = newRTL;
        panel.classList.toggle('fab-rtl', isRTL);
        input.placeholder = isRTL ? CONFIG.placeholderAR : CONFIG.placeholderEN;
        document.getElementById('fab-welcome-text').textContent = isRTL ? CONFIG.welcomeAR : CONFIG.welcomeEN;
      }
    });
    sendBtn.addEventListener('click', send);

    /* Quick chips */
    const chipsContainer = panel.querySelector('#fab-chips');
    CONFIG.chipLabels.forEach(chip => {
      const b = el('button', { class: 'fab-chip' });
      b.textContent = chip.en;
      b.addEventListener('click', () => {
        input.value = chip.en;
        send();
      });
      chipsContainer.appendChild(b);
    });
  }

  /* ---- Toggle ---- */
  function togglePanel() {
    isOpen = !isOpen;
    const panel = document.getElementById('fab-chat-panel');
    const trigger = document.getElementById('fab-chat-trigger');
    panel.classList.toggle('fab-visible', isOpen);
    trigger.classList.toggle('fab-open', isOpen);
    if (isOpen) {
      document.getElementById('fab-input').focus();
    }
  }

  /* ---- Send Message ---- */
  async function send() {
    const input = document.getElementById('fab-input');
    const text = input.value.trim();
    if (!text || sending) return;

    /* Detect language */
    if (detectArabic(text)) {
      isRTL = true;
      document.getElementById('fab-chat-panel').classList.add('fab-rtl');
    }

    /* Hide welcome & chips on first message */
    const welcome = document.querySelector('.fab-welcome');
    const chips = document.getElementById('fab-chips');
    if (welcome) welcome.style.display = 'none';
    if (chips) chips.style.display = 'none';

    /* Add user bubble */
    addMessage(text, 'user');
    input.value = '';
    input.focus();
    sending = true;
    document.getElementById('fab-send').disabled = true;
    showTyping(true);

    /* Build conversation */
    conversation.push({ role: 'user', content: text });

    try {
      const reply = await callAI(conversation);

      /* Check for [SEARCH:keyword] pattern */
      const searchMatch = reply.match(/\[SEARCH:([^\]]+)\]/);
      let cleanReply = reply.replace(/\[SEARCH:[^\]]+\]/g, '').trim();

      showTyping(false);
      addMessage(cleanReply, 'assistant');
      conversation.push({ role: 'assistant', content: cleanReply });

      /* Product search if keyword found */
      if (searchMatch) {
        await searchProducts(searchMatch[1].trim());
      }
    } catch (err) {
      showTyping(false);
      const errorMsg = isRTL
        ? 'عذراً، حدث خطأ. يرجى المحاولة مرة أخرى أو الاتصال بنا على 24922191 965+ أو واتساب 99089559.'
        : 'Sorry, something went wrong. Please try again or contact us at +965 24922191 or WhatsApp 99089559.';
      addMessage(errorMsg, 'assistant');
      console.error('Falsabih AI Error:', err);
    }

    sending = false;
    document.getElementById('fab-send').disabled = false;
  }

  /* ---- Call AI via Anthropic API ---- */
  async function callAI(messages) {
    const res = await fetch(CONFIG.apiUrl, {
      method: 'POST',
      headers: {
        'x-api-key': CONFIG.apiKey,
        'anthropic-version': '2023-06-01',
        'anthropic-dangerous-direct-browser-access': 'true',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        model: CONFIG.model,
        max_tokens: CONFIG.maxTokens,
        system: CONFIG.systemPrompt,
        messages: messages.slice(-10) /* Keep last 10 for context window */
      })
    });

    if (!res.ok) {
      const errBody = await res.text().catch(() => '');
      throw new Error(`API error ${res.status}: ${errBody}`);
    }

    const data = await res.json();
    return data.content?.[0]?.text || 'No response';
  }

  /* ---- Product Search ---- */
  async function searchProducts(query) {
    try {
      const res = await fetch(
        `${CONFIG.shopDomain}/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`
      );
      if (!res.ok) return;
      const data = await res.json();
      const products = data?.resources?.results?.products || [];
      if (products.length === 0) return;

      const messagesDiv = document.getElementById('fab-messages');
      const cardsWrap = el('div', { class: 'fab-products' });

      products.forEach(p => {
        const price = p.price ? `${parseFloat(p.price).toFixed(3)} KD` : '';
        const imgUrl = p.image || p.featured_image?.url || '';
        const link = `${CONFIG.shopDomain}/products/${p.handle}`;

        const card = el('a', {
          class: 'fab-product-card',
          href: link,
          target: '_blank',
          rel: 'noopener'
        });
        card.innerHTML = `
          ${imgUrl ? `<img class="fab-product-img" src="${imgUrl}" alt="${escHTML(p.title)}" loading="lazy"/>` : '<div class="fab-product-img"></div>'}
          <div class="fab-product-info">
            <div class="fab-product-title">${escHTML(p.title)}</div>
            ${p.vendor ? `<div class="fab-product-vendor">${escHTML(p.vendor)}</div>` : ''}
            ${price ? `<div class="fab-product-price">${price}</div>` : ''}
          </div>`;
        cardsWrap.appendChild(card);
      });

      messagesDiv.insertBefore(cardsWrap, document.getElementById('fab-typing'));
      scrollDown();
    } catch (e) {
      console.warn('Product search failed:', e);
    }
  }

  /* ---- UI Helpers ---- */
  function addMessage(text, role) {
    const messagesDiv = document.getElementById('fab-messages');
    const bubble = el('div', { class: `fab-msg fab-msg-${role}` });
    bubble.innerHTML = formatText(text);
    messagesDiv.insertBefore(bubble, document.getElementById('fab-typing'));
    scrollDown();
  }

  function showTyping(show) {
    document.getElementById('fab-typing').classList.toggle('fab-show', show);
    if (show) scrollDown();
  }

  function scrollDown() {
    const m = document.getElementById('fab-messages');
    requestAnimationFrame(() => { m.scrollTop = m.scrollHeight; });
  }

  function formatText(text) {
    return escHTML(text)
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br/>');
  }

  function escHTML(s) {
    const d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function el(tag, attrs) {
    const e = document.createElement(tag);
    if (attrs) Object.entries(attrs).forEach(([k, v]) => e.setAttribute(k, v));
    return e;
  }

  /* ---- Init ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildWidget);
  } else {
    buildWidget();
  }
})();
